var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumorous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 0C19.7368 0 25.333 5.59625 25.333 12.5C25.333 19.4037 19.7368 25 12.833 25C5.92926 25 0.333008 19.4037 0.333008 12.5C0.333008 5.59625 5.92926 0 12.833 0ZM12.833 11.25C10.333 11.25 8.24926 11.6663 6.58301 12.5C6.58301 14.1576 7.24149 15.7473 8.41359 16.9194C9.58569 18.0915 11.1754 18.75 12.833 18.75C14.4906 18.75 16.0803 18.0915 17.2524 16.9194C18.4245 15.7473 19.083 14.1576 19.083 12.5C17.4168 11.6663 15.333 11.25 12.833 11.25ZM8.45801 6.25C7.01801 6.25 5.80551 7.225 5.44301 8.55L5.39551 8.75H11.5205C11.3764 8.04415 10.9929 7.40975 10.4348 6.95418C9.87675 6.49861 9.17842 6.24985 8.45801 6.25ZM17.208 6.25C15.768 6.25 14.5555 7.225 14.193 8.55L14.1455 8.75H20.2705C20.1264 8.04415 19.7429 7.40975 19.1848 6.95418C18.6267 6.49861 17.9284 6.24985 17.208 6.25Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumorous);
export default __webpack_public_path__ + "static/media/humorous.bf725a71db386e79d99f6b365baf2960.svg";
export { ForwardRef as ReactComponent };